import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * A directive that automatically sets focus to an element after view initialization.
 * 
 * This directive simply applies focus to its host element once the view is 
 * fully initialized. It can be applied to any focusable element to ensure
 * it receives initial focus when rendered.
 * 
 * @example
 * ```html
 * <input type="text" autofocus>
 * <button autofocus>Submit</button>
 * ```
 */
@Directive({
  selector: '[autofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  /**
   * @internal Reference to the host element that will receive focus.
   */
  constructor(private host: ElementRef) {}

  /**
   * Lifecycle hook that runs after the component view is initialized.
   * Sets focus to the host element.
   */
  ngAfterViewInit() {
    this.host.nativeElement.focus();
  }
}
